import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import SplitBusinessEcommerceBannerBlockData from '../../../Models/Content/SplitBusinessEcommerceBannerBlockData';
import SplitBusinessEcommerceBannerMain from './SplitBusinessEcommerceBannerMain';

export default class SplitBusinessEcommerceBannerBlock extends EpiComponent<SplitBusinessEcommerceBannerBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <SplitBusinessEcommerceBannerMain context={this.getContext()} contentData={this.props.data} />;
  }
}
